import { Col, Row } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import formatDateWithTime from 'utils/formatDateWithTime';

interface IProps {
  cart: any;
}

export default function PreOrderInfo(props: IProps): JSX.Element {
  const { cart } = props;

  console.log(cart);

  return (
    <>
      <div className="mb-4 flex flex-col gap-4 pb-20 border-b-2 border-[#E1E3E6]">
        <Content>
          <div className="text-xl font-bold mb-6">Thông tin giỏ hàng</div>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={24}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="text-base text-neutral-40 flex gap-2" span={4}>
                  Tên giỏ hàng
                </Col>
                <Col className="text-base font-semibold" span={20}>
                  : {cart?.cart_name}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="text-base text-neutral-40 flex gap-2" span={8}>
                  Loại giỏ hàng
                </Col>
                <Col className="text-base font-semibold" span={16}>
                  : {cart?.cart_type_name}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="text-base text-neutral-40 flex gap-2" span={8}>
                  Thời gian hiện hành
                </Col>
                <Col className="text-base font-semibold" span={16}>
                  : {formatDateWithTime(cart?.release_date)}
                  {'  -  '}
                  {formatDateWithTime(cart?.expiration_date)}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="text-base text-neutral-40 flex gap-2" span={4}>
              Nhãn hàng
            </Col>
            <Col className="text-base font-semibold" span={20}>
              : {(cart?.nhan_hang || []).join(', ')}
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col
              span={24}
              className="text-base text-neutral-40 flex gap-2 mb-2"
            >
              Mô tả
            </Col>
            <Col className="text-base font-semibold" span={24}></Col>
          </Row>

          <div className="my-4 border-2 border-dashed border-neutral-90"></div>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={8}>
                  Người tạo
                </Col>
                <Col className="" span={16}>
                  : {cart?.created_by}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={8}>
                  Email
                </Col>
                <Col className="" span={16}>
                  : {cart?.email}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={8}>
                  Khối phát hành
                </Col>
                <Col className="" span={16}>
                  : {cart?.division}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={8}>
                  Công ty phát hành
                </Col>
                <Col className="" span={16}>
                  : {cart?.company}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={4}>
              Đơn vị phát hành
            </Col>
            <Col className="" span={20}>
              : {cart?.department_name}
            </Col>
          </Row>

          <div className="my-4 border-2 border-dashed border-neutral-90"></div>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={8}>
                  Số lượng phân bổ
                </Col>
                <Col className="" span={16}>
                  : {''}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={8}>
                  CH được đăng ký
                </Col>
                <Col className="" span={16}>
                  :{' '}
                  {cart?.cua_hang == null
                    ? '-'
                    : (cart?.cua_hang || []).join(', ')}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={24}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={4}>
                  Giá trị vốn tồn đăng ký
                </Col>
                <Col className="" span={20}>
                  : {''}
                </Col>
              </Row>
            </Col>
          </Row>

          <div className="my-4 border-2 border-dashed border-neutral-90"></div>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={24}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={4}>
                  Danh mục trong giỏ hàng
                </Col>
                <Col className="" span={20}>
                  : {''}
                </Col>
              </Row>
            </Col>
          </Row>
        </Content>
      </div>
    </>
  );
}
